/**
 * Pure helpers for ProductVariants validation and display.
 * Extracted to keep component complexity low.
 *
 * Manual verification (order/shipment flows):
 * - Order detail (edit): Max Qty / Pending to Ship use quantityAvailable; red border when value > quantityAvailable.
 * - Shipment create modal, carton: Pending to Ship shows maxShipmentQty; red border when qty > maxShipmentQty; no Max Qty in variants table.
 * - Shipment create modal, variant: Max Qty shows maxShipmentQty; red border when value > maxShipmentQty (not quantityAvailable).
 * - Confirmed/rejected/shipment view: no red border (showQuantityExceedValidation false).
 */

export function hasShipmentMaxQty(isShipmentSettingsModal, item) {
  return Boolean(isShipmentSettingsModal && item != null && item.maxShipmentQty !== undefined)
}

/**
 * @param {Object} opts
 * @param {boolean} opts.showValidation
 * @param {boolean} opts.isCarton
 * @param {boolean} opts.hasShipmentMax
 * @param {function(number, *): boolean} opts.isProductItemValid
 * @param {{ value: number, quantityAvailable: * }} opts.item
 */
export function isQuantityExceedError(opts) {
  const {
 showValidation, isCarton, hasShipmentMax, isProductItemValid, item,
} = opts
  if (hasShipmentMax) return false
  return showValidation && !isCarton && isProductItemValid(item.value, item.quantityAvailable)
}

export function isShipmentQtyExceedError(showValidation, item) {
  return showValidation && item.maxShipmentQty !== undefined && (item.value || 0) > item.maxShipmentQty
}

export function getDisplayMaxQtyValue(hasShipmentMax, item) {
  const val = hasShipmentMax ? item.maxShipmentQty : item.quantityAvailable
  return val != null ? val : ''
}
